// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xcLM","label":"styles_label__239yJ"};